// extracted by mini-css-extract-plugin
export var actionText = "_n5-4";
export var container = "_n5-0";
export var leftSection = "_n5-1";
export var rightSection = "_n5-2";
export var settingsButton = "_n5-6";
export var settingsIcon = "_n5-7";
export var shortcut = "_n5-5";
export var shortcutGroup = "_n5-3";